import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { tablet } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface Props {
  isActive?: boolean;
  isPlaceholder?: boolean;
}

export const FilterBarContainer = styled.div`
  position: sticky;
  top: 0;
  ${AlignCenter}
  background-color: var(--background-secondary);
  z-index: var(--z-index-header);
`;

// left content for assignee dropdown
export const LeftContent = styled.div`
  display: flex;
  min-width: 232px;
  max-width: 280px;
  padding: var(--space-24) var(--space-24) var(--space-12);
  border-right: 0.5px solid var(--border-primary);
  background-color: var(--background-secondary);
  z-index: var(--z-index-header);
  position: sticky;
  left: 0;
`;

export const AssigneeDropdown = styled.div<Props>`
  width: -webkit-fill-available;
  padding: var(--space-8) var(--space-8) var(--space-8) var(--space-12);
  ${AlignCenter}
  gap: var(--space-10);
  box-shadow: ${({ isActive }) => (isActive ? 'var(--border-active)' : 'var(--border)')};
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
  cursor: pointer;
`;

export const Icon = styled.div`
  ${FlexCenter}
`;

export const ArrowIcon = styled(Icon)<Props>`
  svg {
    transition: transform var(--transition-fast) ease;
    transform: ${({ isActive }) => (isActive ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const Label = styled.p<Props>`
  cursor: pointer;
  margin: var(--space-0);
  width: 100%;
  ${Typography.body_lg}
  color: ${({ isPlaceholder }) => (isPlaceholder ? 'var(--text-placeholder)' : 'var(--text-primary)')};
`;

export const BottomData = styled.div`
  height: 100%;
`;

export const RightContent = styled.div`
  width: 100%;
  ${AlignCenter}
  padding: var(--space-24) var(--space-24) var(--space-12);
  background-color: var(--background-secondary);
  ${tablet(css`
    width: unset;
  `)}
`;

export const DateChipContainer = styled.div`
  width: 100%;
  background-color: var(--background-tertiary);
  box-shadow: var(--border);
  ${AlignCenter}
  gap: var(--space-12);
  border-radius: var(--border-radius-6);
`;

export const DateChip = styled.div`
  min-width: 76px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: var(--space-8) var(--space-10);
`;

export const DateText = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-secondary);
`;
